export const pathnameIsRentalComparables = (pathname: string): boolean =>
  pathname.split('/').includes('rental-features');
